import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';

import LayoutSlice from '~/common/stores/layout.slice.ts';
import AuthSlice from '~/features/auth/stores/auth.slice.ts';
import FaqSlice from '~/features/notices/stores/faq.slice.ts';
import NoticesSlice from '~/features/notices/stores/notices.slice.ts';
import ProductsSlice from '~/features/products/stores/products.slice.ts';
import PurchasesSlice from '~/features/purchases/stores/purchases.slice.ts';
import UsageHistorySlice from '~/features/usage-history/stores/usage-history.slice.ts';

import type { TypedUseSelectorHook } from 'react-redux';

const ACTION_STORE_CLEAR = { type: 'root/STORE_CLEAR' } as const;

const combined = combineReducers({
  layout: LayoutSlice.reducer,
  auth: AuthSlice.reducer,
  faq: FaqSlice.reducer,
  notices: NoticesSlice.reducer,
  products: ProductsSlice.reducer,
  purchases: PurchasesSlice.reducer,
  usageHistory: UsageHistorySlice.reducer,
});

const rootReducer: typeof combined = (state, action) => {
  switch (action.type) {
    case ACTION_STORE_CLEAR.type:
      return combined(undefined, action);

    default:
      return combined(state, action);
  }
};

export const store = configureStore({
  devTools: process.env.NODE_ENV === 'development',
  middleware: getDefaultMiddleware => getDefaultMiddleware({ serializableCheck: false }),
  reducer: rootReducer,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
